
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vscode-extension",
      function () {
        return require("private-next-pages/vscode-extension.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vscode-extension"])
      });
    }
  